export const TEMPLATE_NAME_META_TAG = 'templateName';
export const PAGE_GROUP_META_TAG = 'pageGroup';

export const templateNames = {
  default: 'PCC NO TEMPLATE',
  homepage: 'PCC HomePage',
  allCategories: 'PCC Shop All Categories Page',
  category: 'PCC PLP',
  product: 'PCC PDP',
  pdpBundle: 'PCC PDP Bundle',
  package: 'PCC PDP Kit',
  partsManuals: 'PCC Parts Manuals',
  shoppingCart: 'PCC Shopping Cart Page',
  checkout: 'PCC Checkout',
  orderConfirmation: 'PCC Order Confirmation Page',
  partStoreLanding: 'PCC PartStore Landing',
  resourceCenter: 'PCC Resource Center',
  aboutUs: 'PCC About Us Page',
  sitemap: 'PCC Sitemap',
  finningCALanding: 'PCC CATFinningCALanding',
  finningSKLanding: 'PCC CATFinningSKLanding',
  finningUKLanding: 'PCC CATFinningUKLanding',
  cmcCampaign: 'PCC CMC Campaign Page',
  policies: 'PCC Policies',
  contactUs: 'PCC Contact Us',
  legalNotices: 'PCC Legal Notices',
  termsAndConditions: 'PCC Dealer Terms & Conditions Page',
  dealerPrivacyPolicy: 'PCC Dealer Privacy Policy Page',
  error: 'PCC Error Page',
  ssroBundle: 'SSRO Bundle',
  searchDisplay: 'PCC SearchDisplay',
  sis2Campaign: 'PCC SIS2 Campaign Landing Page',
  mlp: 'PCC MLP',
  marketing: 'PCC Marketing Page',
  advancedSearch: 'PCC Advanced Search Page',
  controlCenter: 'PCC Control Center Page',
  orderHistory: 'PCC Order History Page',
  orderHistoryDetail: 'PCC Order History Detail Page',
  coreTracking: 'PCC Core Tracking Page',
  pendingQuotes: 'PCC Pending Quotes Page',
  pendingQuotesDetail: 'PCC Pending Quote Details Page',
  saveList: 'PCC Saved List Page',
  saveListDetail: 'PCC Saved List Details Page',
  organizationAndUsers: 'PCC Organizations And Users Page',
  calApprovalListing: 'PCC CAL Approval Listing Page',
  calApprovalDetail: 'PCC CAL Approval Details Page',
  notificationsPreferences: 'PCC Notifications Preferences Page',
  myEquipment: 'PCC My Equipment Page',
  addressBook: 'PCC Address Book Page',
  shoppingPreferences: 'PCC Shopping Preferences Page',
  personalInformation: 'PCC Personal Information Page',
  paymentMethod: 'PCC Payment Methods Page',
  accountPage: 'PCC My Account Page',
  registration: 'PCC Registration Page',
  csrLanding: 'PCC CSR Landing Page',
  adp: 'PCC ADP',
  commonParts: 'PCC Common Parts Page',
  quickOrder: 'PCC Quick Order Page',
  orderReturnRequest: 'PCC Order Return Request Page',
  backToPCCFromB2C: 'Back to PCC From B2C Page',
  creditCartPayment: 'PCC Credit Card Payment Page',
  storeLocator: 'PCC Store Locator Display Page',
  calApproval: 'PCC CAL Approval Page',
  pickupAndDelivery: 'PCC Pickup And Delivery Page',
  warrantyAndReturns: 'PCC Warranty & Returns',
  catPrivacyPolicy: 'CAT Privacy Policy Page',
  recentlyViewed: 'PCC recently viewed products Page'
};

export const pageGroups = {
  notFoundPage: '404Page',
  shoppingCartPage: 'ShoppingCart',
  searchPage: 'Search',
  errorPage: 'Error',
  productPage: 'Product',
  partsManualPage: 'PartsManual',
  controlCenter: 'ControlCenter',
  homePage: 'HomePage',
  saveListDetail: 'SaveListDetail',
  myAccount: 'MyAccount',
  recentlyViewed: 'RecentlyViewed'
};
